import type { PaletteOptions } from '@mui/material/styles';

import { colors } from './colors';

export const lightPalette: PaletteOptions = {
    mode: 'light',

    /**
     * Light mode can use the real brand color directly.
     */
    primary: {
        main: colors.brand[600],
        dark: colors.brand[700],
        light: colors.brand[500],
        contrastText: '#FFFFFF',
    },

    secondary: {
        main: colors.neutral[500],
        dark: colors.neutral[600],
        light: colors.neutral[400],
        contrastText: '#FFFFFF',
    },

    success: {
        main: colors.status.success.strong,
        dark: '#15803D',
        light: colors.status.success.main,
        contrastText: '#FFFFFF',
    },

    warning: {
        main: colors.status.warning.strong,
        dark: '#B45309',
        light: colors.status.warning.main,
        contrastText: '#FFFFFF',
    },

    error: {
        main: colors.status.error.strong,
        dark: '#B91C1C',
        light: colors.status.error.main,
        contrastText: '#FFFFFF',
    },

    info: {
        main: colors.status.info.strong,
        dark: '#0369A1',
        light: colors.status.info.main,
        contrastText: '#FFFFFF',
    },

    background: {
        default: colors.light.background.default,
        paper: colors.light.background.paper,

        light: colors.light.background.light,
        extraLight: colors.light.background.extraLight,
        tab: colors.light.background.tab,

        chat: {
            primary: colors.light.chat.primary,
            secondary: colors.light.chat.secondary,
            button: colors.light.chat.button,
        },
    },

    text: {
        primary: colors.light.text.primary,
        secondary: colors.light.text.secondary,
        light: colors.light.text.light,

        disabled: colors.light.text.disabled,
    },

    notification: {
        primary: colors.light.notification.primary,
        secondary: colors.light.notification.secondary,
    },

    border: {
        light: colors.light.border.light,
        main: colors.light.border.main,
        strong: colors.light.border.strong,
        error: colors.light.border.error,
    },

    gradientButton: {
        base: colors.gradients.primaryButton,
        selected: colors.gradients.primaryButtonSelected,
        hover: colors.gradients.primaryButtonHover,
    },

    divider: colors.light.border.main,

    action: {
        active: colors.brand[600],

        hover: colors.alpha.brand[4],
        hoverOpacity: 0.04,

        selected: colors.alpha.brand[8],
        selectedOpacity: 0.08,

        focus: colors.alpha.brand[12],
        focusOpacity: 0.12,

        disabled: 'rgba(23, 32, 51, 0.30)',
        disabledBackground: 'rgba(23, 32, 51, 0.05)',
        disabledOpacity: 0.38,
    },
};